import { Box, Typography } from '@mui/material';
// Consntants
import { DESIGN_TOKENS } from '@src/constants/design-tokens';
import type { ReactElement } from 'react';

export default function NotFound(): ReactElement {
  return (
    <Box
      marginLeft={2}
      marginRight={2}
      minWidth={DESIGN_TOKENS.layout.contentWidth.min}
      maxWidth={DESIGN_TOKENS.layout.contentWidth.max}
    >
      <Box marginTop="120px">
        <Typography variant="h1" align="center">
          404
        </Typography>
        <Typography variant="h3" align="center">
          ❌ Content Not Found
        </Typography>
        <Box marginTop="24px">
          <Typography variant="h4" align="center">
            お探しのページは見つかりません
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
